import { useTranslation } from "next-i18next";
import { useContext } from "react";

import { Header } from "@baseComponents/Header";
import { CTA } from "@components/CTA";
import { BlogContext } from "@context/BlogContext";
import { portfolioArticleCards } from "@portfolios";

import { ProjectsLayout } from "./ProjectsLayout";
import {
  StyledArticlesMainLayout,
  StyledArticlesSeeAlso,
} from "./styles.styled";

export default function MDXPagePL() {
  const blogContext = useContext(BlogContext);
  const { t } = useTranslation();

  return (
    <ProjectsLayout
      title="Nasze realizacje: od pomysłu do efektu"
      description="Zobacz, jak zamieniamy pomysły w działające produkty cyfrowe. Nasze projekty to przemyślany design, solidny kod i realny wpływ na biznes. Sprawdź, co udało nam się stworzyć wspólnie z naszymi klientami."
    >
      <Header
        header="Case study"
        subheader="Od koncepcji do realizacji - zobacz jak przekształcamy pomysły w rozwiązania dla naszych klientów."
      />

      <StyledArticlesMainLayout
        articles={portfolioArticleCards.map(({ pl }) => pl)}
      />

      <StyledArticlesSeeAlso
        articles={blogContext.getSortedArticleCards()}
        sectionHeader={t("projects_page.see_also_header")}
        sectionSubheader={t("projects_page.see_also_subheader")}
      />

      <CTA
        buttonText="Darmowa Konsultacja"
        header="Porozmawiajmy o Twoim projekcie."
        subheader="Skorzystaj z bezpłatnej konsultacji i przekonaj się jak możemy wcielić Twoje pomysły w życie."
      />
    </ProjectsLayout>
  );
}
